import { Settings } from 'luxon';

import { selectCurrentOrganization } from './selectors';
import { useAppSelector } from 'src/app/store/hooks';
import { useOrganizationSettingsRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';

export function useSetDefaultTimeZone() {
  const currentOrganization = useAppSelector(selectCurrentOrganization);

  const { data: organizationSettings, isLoading } =
    useOrganizationSettingsRetrieveQuery(
      {},
      {
        skip: !currentOrganization?.id,
      }
    );

  Settings.defaultZone =
    organizationSettings?.headquarters_location?.time_zone_name ??
    Settings.defaultZone;

  return {
    isLoading,
  };
}
